import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import { CustomLoader } from '../utils/CommonLibrary';
import { decryptData } from '../utils/Utils';
import { fetchPoolDataList, createNewPool } from '../../services/hih/Service';
import CalendarDatePicker from '../componenents/CalendarDatePicker';
import BackendDrivenDataTable from '../cn/components/common/BackendDrivenDataTable';
import AddMember from './AddMember';

const RefillPoolV3 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedCurrentStatus, setSelectedCurrentStatus] = useState('');
    const [poolFilterType, setPoolFilterType] = useState('');
    const [poolMemberType, setPoolMemberType] = useState('memberaccepted');
    const [listData, setListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedMembershipNo, setSelectedMembershipNo] = useState("");

    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("createdTime");
    const [sortDirection, setSortDirection] = useState('desc');
    const [error, setError] = useState("");

    useEffect(() => {
        getList()
    }, [page, perPage, sortColumn, sortDirection, poolFilterType])

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const getList = async () => {
        try {
            setListData([]);
            setLoading(true);

            await fetchPoolDataList(poolFilterType, page, perPage, sortColumn, sortDirection)
                .then((response) => {
                    if (response.data.code == 200) {
                        setShowTable(true);
                        setListData(response.data.data.members);
                        setTotalRows(response.data.data.totalRows)
                    }
                }).finally(() => {
                    setLoading(false);
                });
        } catch (error) {
            console.error('Error=', error);
        }
    }
    const getPool = async () => {
        try {
            setListData([]);
            setPage(1);
            setLoading(true);

            await createNewPool(poolMemberType)
                .then((response) => {
                    if (response.data.code == 200) {
                        getList();
                        if (response.data.data.foundNewRecords == "N") {
                            setError("No new records to pool");
                        }
                    }
                }).finally(() => {
                    setLoading(false);
                    setShowTable(true);
                });
        } catch (error) {
            console.error('Error=', error);
        }
    }

    const columns = [
        {
            name: 'Action',
            cell: row => (
                <button class="action-button blue-btn me-2" onClick={() => {
                    if (row.currentStatus == "due" || row.WAMessageReason === "lightccm") {
                        window.location.href = `/rf-member-profile?mno=${row.membershipNo}`;
                    } else {
                        setSelectedCurrentStatus(row.poolTypeRaw);
                        setSelectedMembershipNo(row.membershipNo);
                        setShowModal(true);
                    }
                }}>{row.currentStatus === "due" || row.WAMessageReason === "lightccm" ? "Recommend" : "Onboard"}
                </button >
            ),
            sortable: false,
        },
        {
            name: 'Pool Type',
            selector: row => row.poolType,
            sortable: true,
        },
        {
            name: 'Member ID',
            selector: row => row.membershipNo,
            sortable: true,
        },
        {
            name: 'Main Membership No',
            selector: row => row.mainMembershipNo,
            sortable: true,
        },
        {
            name: 'Member Name',
            selector: row => row.memberName,
            sortable: true,
        },
        {
            name: 'Mobile',
            selector: row => row.memberMobile,
            sortable: true,
        },
        {
            name: 'Gender',
            selector: row => row.gender,
            sortable: true,
        },
        {
            name: 'Age',
            selector: row => row.age,
            sortable: true,
        },
        {
            name: 'VIP Code',
            selector: row => row.vipCode,
            sortable: true,
        },
        {
            name: 'Ambassador',
            selector: row => row.ambassadorInd,
            sortable: true,
        },
        {
            name: 'ID Card No',
            selector: row => row.idCardNo,
            sortable: true,
        },
        {
            name: 'Net Type',
            selector: row => row.netType,
            sortable: true,
        },
        {
            name: 'Service Recommendation Type',
            selector: row => row.serviceRecommendationType,
            sortable: true,
        },
        {
            name: 'Contract No',
            selector: row => row.contractNo,
            sortable: true,
        },
        {
            name: 'Customer Name',
            selector: row => row.customerName,
            sortable: true,
        },
        {
            name: 'Contract Term Date',
            selector: row => row.contractTermDate,
            sortable: true,
        },
        {
            name: 'WhatsApp Sent Date',
            selector: row => row.WASentTime,
            sortable: true,
        },
        {
            name: 'WhatsApp Reply Date',
            selector: row => row.WAReplyTime,
            sortable: true,
        },
        {
            name: 'Data Source',
            selector: row => row.dataSource,
            sortable: true,
        }
    ];
    return (
        <>
            <section className='ContentCareNavigator'>
                <div className="row align-items-center pb-3 sticky-top-bar">
                    <div className="col-md">
                        <h1 className="main-title">Refill Pool</h1>
                    </div>
                    <div className="col-md text-end">

                    </div>
                </div>

                <div className='reports-programs mb-3'>
                    <div className="row align-items-center">
                        <div className="col-md-auto">
                            <img src="https://storage.googleapis.com/ksabupatest/2024/09/24/5jw18/wh4l7e7hk4.png" alt="Invited Members icon" style={{ height: "140px" }} className="img-fluid mb-0" />
                        </div>
                        <div className="col-md">
                            <p className="mb-0">The Refill Pool module allows you to onboard the not-onboarded users and manage the service recommendations.</p>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row align-items-center pb-3">

                        {/* <div className='member-engagement mb-3' style={{ marginBottom: "1rem !important" }}>
                            <div className="row align-items-center">
                                <div className="col-md-auto ps-3">
                                    <h3 className='dashboard-graph-title mb-1'>Pool Members Type:</h3>
                                </div>
                                <div className="col-md-4">
                                    <select className='form-select input-field-ui w-100' name="setPoolMemberType" value={poolMemberType} onChange={(e) => setPoolMemberType(e.target.value)}>
                                        <option value="memberaccepted">Members who accepted</option>
                                        <option value="memberdeclined">Members who declined</option>
                                        <option value="whatsappmessagesent">Members who did not respond</option>
                                    </select>
                                </div>
                                <div className='col-md-2 ps-0'>
                                    <Button variant="primary" className="btn btn-primary add-new-program-btn me-2" type="button" onClick={() => getPool()}
                                    >Get Pool</Button>
                                </div>
                            </div>
                        </div> */}


                        <div className='container-fluid mb-2 p-2' style={{ backgroundColor: "#fff", borderRadius: "14px", boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)" }}>
                            <div className="row align-items-center">
                                <div className="col-md-6 p-2 tw-ml-3 tw-pr-4" style={{ backgroundColor: "#f0f4ff", borderRadius: "14px" }}>
                                    <div className='row align-items-center'>
                                        <div className='col-md-4'>
                                            <h3 className='dashboard-graph-title mb-1 ps-2'>Pool Selection Criteria:</h3>
                                        </div>
                                        <div className='col-md-5 ps-0'>
                                            <select
                                                className='form-select input-field-ui w-100'
                                                name="setPoolMemberType"
                                                value={poolMemberType}
                                                onChange={(e) => setPoolMemberType(e.target.value)}
                                            >
                                                <option value="memberaccepted">Members who accepted</option>
                                                <option value="memberdeclined">Members who declined</option>
                                                <option value="whatsappmessagesent">Members who did not respond</option>
                                            </select>
                                        </div>
                                        <div className='col-md-3 p-2'>
                                            <Button
                                                variant="primary"
                                                className="btn btn-primary add-new-program-btn w-100"
                                                type="button"
                                                onClick={() => getPool()}
                                            >
                                                Get Pool
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showTable && (
                            <div className='comntent-CareNavigator mb-3 border'>


                                <div className="row p-2 pt-0">
                                    {/* <div class="col-md-12 mt-0 px-2"><hr/></div> */}
                                    {/*<div className='col-6'>
                                        <div className='row align-items-center'>
                                            <div className='col-md-12 mb-2'>
                                                <label htmlFor="" className='form-label mb-0'>Filter the pool by member response</label>
                                            </div>
                                            <div className='col-md-6 ps-2'>
                                                <select name="poolFilterType" value={poolFilterType} onChange={(e) => setPoolFilterType(e.target.value)} className='col-3 form-select input-field-ui w-100'>
                                                    <option value="">Select</option>
                                                    <option value="memberaccepted">Members who accepted</option>
                                                    <option value="memberdeclined">Members who declined</option>
                                                    <option value="whatsappmessagesent">Members who did not respond</option>
                                                </select>
                                            </div>

                                        </div>
                                    </div>*/}
                                    {error && <div className="tw-bg-red-100 tw-text-red-700 tw-p-2 tw-rounded tw-mt-2">{error}</div>}

                                    <div className="col-md-12 mt-3">
                                        {
                                            loading ? <CustomLoader /> :
                                                <BackendDrivenDataTable
                                                    data={listData}
                                                    loading={loading}
                                                    totalRows={totalRows}
                                                    page={page}
                                                    perPage={perPage}
                                                    sortColumn={sortColumn}
                                                    sortDirection={sortDirection}
                                                    columns={columns}
                                                    fetchTableData={getList}
                                                    setPage={setPage}
                                                    setSortColumn={setSortColumn}
                                                    setSortDirection={setSortDirection}
                                                    setPerPage={setPerPage}
                                                />
                                        }
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            {showModal && selectedMembershipNo != "" && <AddMember status="add" heading="Add New Member" hideModal={() => {
                setShowModal(false);
                setSelectedMembershipNo("");
            }} membershipNumber={selectedMembershipNo} currentStatus={selectedCurrentStatus} />
            }
        </>
    )
}

export default RefillPoolV3